module.exports = __webpack_public_path__ + "img/Slice3en-min.59f04214.png";